









import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { ENV } from '../environment';

@Component({
  components: { },
})
export default class CheckSheetItem extends Vue {

  @Prop()
  private label!: string

  @Prop()
  private value?: boolean

  @Prop({
    default: () => Math.random().toString(36).substr(2, 16)
  })
  private id!: string

  public get highlightError(): boolean {
    return ENV.isDev
  }

  onChanged(event: any) {
    this.input(event.target.checked)
  }
  
  @Emit()
  input(value:boolean) {
  }
}

